import { useEffect, useState } from "react";
import { X, Heart } from "lucide-react";
import { api } from "../../lib/api";

const SESSION_KEY = "bigeldi_popup_closed_session";
const STORAGE_KEY = "bigeldi_popup_closed_until";
const SUPPRESS_DAYS = 3;

export default function PromoPopup() {
  const [cfg, setCfg] = useState(null);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    // Aynı oturumda kapatıldıysa veya 3 gün bastırma aktifse gösterme
    if (sessionStorage.getItem(SESSION_KEY)) return;
    const until = parseInt(localStorage.getItem(STORAGE_KEY) || "0", 10);
    if (until && Date.now() < until) return;
    api.get("/popup").then(({ data }) => {
      if (data?.active) {
        setCfg(data);
        const t = setTimeout(() => setOpen(true), 1200);
        return () => clearTimeout(t);
      }
    }).catch(() => {});
  }, []);

  const close = () => {
    setOpen(false);
    sessionStorage.setItem(SESSION_KEY, "1");
    localStorage.setItem(STORAGE_KEY, String(Date.now() + SUPPRESS_DAYS * 86400000));
  };

  if (!open || !cfg) return null;

  return (
    <div className="fixed inset-0 z-[70] flex items-center justify-center p-4" data-testid="promo-popup">
      <div className="absolute inset-0 bg-black/55 backdrop-blur-sm" onClick={close} />
      <div className="relative bg-[#FAF9F5] rounded-3xl shadow-2xl w-full max-w-md overflow-hidden animate-[fadeUp_0.35s_ease]">
        <button onClick={close} className="absolute top-3.5 right-3.5 z-10 p-2 bg-white/80 backdrop-blur rounded-full text-neutral-500 hover:text-neutral-900 transition-colors" aria-label="Kapat" data-testid="popup-close">
          <X size={18} />
        </button>
        {cfg.image_url && (
          <div className="h-44 sm:h-52 overflow-hidden">
            <img src={cfg.image_url} alt={cfg.title} className="w-full h-full object-cover" />
          </div>
        )}
        <div className={`p-7 sm:p-9 text-center ${cfg.image_url ? "" : "pt-12"}`}>
          <div className="inline-flex items-center justify-center w-11 h-11 rounded-full bg-amber-100 text-amber-700 mb-4">
            <Heart size={20} />
          </div>
          <p className="font-mono-ed text-[10px] uppercase tracking-[0.3em] text-neutral-400 mb-1.5" data-testid="popup-title">{cfg.title}</p>
          <h3 className="font-display font-extrabold text-2xl sm:text-3xl tracking-tight text-[#121214]" data-testid="popup-price">{cfg.price_text}</h3>
          <p className="text-sm text-neutral-500 mt-3 leading-relaxed" data-testid="popup-desc">{cfg.description}</p>
          <a href={cfg.target_url} target="_blank" rel="noopener noreferrer"
            className="mt-6 inline-flex items-center justify-center h-12 px-9 rounded-full bg-amber-600 text-white text-sm font-semibold hover:bg-amber-500 transition-colors"
            data-testid="popup-cta">
            {cfg.button_text}
          </a>
        </div>
      </div>
    </div>
  );
}
